export default __webpack_public_path__ + "static/media/random-pic.05ffe172.png";